'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@v2/utils';

const SliderTrack = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Track>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Track>
>(({ className, children, ...props }, ref) => (
  <SliderPrimitive.Track
    ref={ref}
    className={cn(
      'relative h-2 w-full grow overflow-hidden rounded-full bg-gray-300',
      className
    )}
    {...props}
  >
    {children}
  </SliderPrimitive.Track>
));

SliderTrack.displayName = SliderPrimitive.Track.displayName;

const SliderThumb = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Thumb>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Thumb>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Thumb
    ref={ref}
    {...props}
    className={cn(
      'ring-offset-background focus-visible:ring-ring relative z-[1] block h-5 w-5 rounded-full border-2 border-gray-800 bg-white transition-colors last:z-[2] focus-visible:z-[3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
      className
    )}
  />
));

SliderThumb.displayName = SliderPrimitive.Thumb.displayName;

const SliderRange = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Range>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Range>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Range
    ref={ref}
    className={cn('absolute h-full bg-gray-800', className)}
    {...props}
  />
));

SliderRange.displayName = SliderPrimitive.Range.displayName;

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, children, onPointerDown, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    data-vaul-no-drag=""
    onPointerDown={(event) => {
      event.stopPropagation();
      onPointerDown?.(event);
    }}
    className={cn(
      'relative flex w-full touch-none select-none items-center',
      className
    )}
    {...props}
  >
    {children}
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider, SliderRange, SliderThumb, SliderTrack };
